import React, { Fragment } from 'react';
import CountUp from 'react-countup';
import Navbar from '../../components/NavbarLanding/NavbarLanding';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo/finale-gattomio.png';
import imgHero from '../../images/landing/imgHero.png';
import imgSicurezza from '../../images/landing/imgSicurezza.png';
import imgComeFunziona from '../../images/landing/imgComeFunziona.png';
import imgMonitoraggio from '../../images/landing/imgMonitoraggio.png';
import imgLifestyle from '../../images/landing/imgLifestyle.jpeg';
import imgOdori from '../../images/landing/odori.jpeg';
import './landing.css';
import {Link} from "react-router-dom";

const Landing = () => {
    return (
        <div className="landing-wrapper">

            {/* STICKY BAR */}
            <div className="sticky-bar">
                <div className="container">
                    <div className="sticky-bar-inner">
                        <p>
                            <i className="ti-truck sticky-icon"></i> Spedizione Gratis +
                            <i className="ti-shield sticky-icon"></i> Prova 30 giorni: se il tuo gatto non la usa, ti rimborsiamo.
                            <strong> Solo 8 posti Pionieri rimasti.</strong>
                        </p>
                        <a href="#prezzi" className="theme-btn-s2 sticky-cta">Acquista Ora</a>
                    </div>
                </div>
            </div>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />

            {/* HERO - Sezione 1 */}
            <section className="landing-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12">
                            <div className="landing-hero-content">
                                <span className="landing-badge">Novità in Italia</span>
                                <h1>Basta Pulire la Lettiera. Per Sempre.</h1>
                                <p>
                                    Kleeo: La Lettiera Smart che Rivoluziona la tua Casa
                                    Silenziosa, sicura e completamente automatica. Design a corpo fisso <strong>Safe-Dome</strong> per la massima protezione del tuo gatto.
                                </p>
                                <div className="landing-hero-cta">
                                    <a href="#prezzi" className="theme-btn-s2">Scopri l'Offerta Lancio</a>
                                    <div className="landing-hero-price">
                                        <span className="price-tag">€399</span>
                                        <span className="price-note">Spedizione gratuita</span>
                                    </div>
                                </div>
                                <div className="landing-hero-trust">
                                    <div className="trust-item">
                                        <i className="ti-shield"></i>
                                        <span>Design senza lame</span>
                                    </div>
                                    <div className="trust-item">
                                        <i className="ti-check"></i>
                                        <span>Sensori peso + infrarossi</span>
                                    </div>
                                    <div className="trust-item">
                                        <i className="ti-truck"></i>
                                        <span>30 giorni soddisfatti o rimborsati</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="landing-hero-image">
                                <img src={imgHero} alt="Lettiera autopulente per gatti" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* TECNOLOGIA E RESISTENZA - Sezione 2 */}
            <section className="landing-social-proof">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="proof-item">
                                <div className="proof-icon" style={{ background: '#E8F4FF' }}>
                                    <i className="ti-heart"></i>
                                </div>
                                <h3><CountUp end={45} enableScrollSpy /> dB</h3>
                                <p>Silenzio Totale (meno di un sussurro)</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="proof-item">
                                <div className="proof-icon" style={{ background: '#FFEFEB' }}>
                                    <i className="ti-shield"></i>
                                </div>
                                <h3><CountUp end={65} enableScrollSpy /> L</h3>
                                <p>Volume Interno Max Comfort</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="proof-item">
                                <div className="proof-icon" style={{ background: '#FFF7E5' }}>
                                    <i className="ti-reload"></i>
                                </div>
                                <h3><CountUp end={2000} enableScrollSpy /> h</h3>
                                <p>Longevità Motore Testata</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12">
                            <div className="proof-item">
                                <div className="proof-icon" style={{ background: '#E5FDFF' }}>
                                    <i className="ti-lock"></i>
                                </div>
                                <h3><CountUp end={100} enableScrollSpy /> %</h3>
                                <p>Sicurezza Safe-Dome</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* COME FUNZIONA - Sezione 3 */}
            <section id="come-funziona" className="landing-how-it-works section-padding-landing">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-12">
                            <div className="section-title">
                                <h3>Come Funziona</h3>
                                <h2>Semplicità in 3 Step</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center" style={{ marginBottom: '60px' }}>
                        <div className="col-lg-6 col-12">
                            <div className="how-it-works-image">
                                <img src={imgComeFunziona} alt="Come funziona la lettiera autopulente" />
                            </div>
                        </div>
                    </div>
                    <div className="timeline-wrap">
                        <div className="timeline-step">
                            <div className="timeline-number">1</div>
                            <h4>Il gatto entra</h4>
                            <p>L'ingresso ultra-basso da 140mm facilita l'accesso. I sensori di peso e infrarossi rilevano il gatto e attendono che abbia finito.</p>
                        </div>
                        <div className="timeline-step">
                            <div className="timeline-number">2</div>
                            <h4>Pulizia automatica</h4>
                            <p>Dopo l'uscita, i residui vengono separati e raccolti nel contenitore da 9L con chiusura automatica. La purificazione ionica a pressione negativa elimina ogni odore.</p>
                        </div>
                        <div className="timeline-step">
                            <div className="timeline-number">3</div>
                            <h4>Tu ti rilassi</h4>
                            <p>Controlla tutto dall'app TUYA: peso del gatto, orari e frequenza di utilizzo. Con un gatto da 4kg, cambi il sacchetto solo ogni 15 giorni.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* SICUREZZA - Sezione 4 */}
            <section id="sicurezza" className="landing-safety section-padding-sicurezza">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12">
                            <div className="safety-image">
                                <img src={imgSicurezza} alt="Sistema di sicurezza lettiera autopulente" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="safety-content">
                                <span className="landing-badge">La sicurezza prima di tutto</span>
                                <h2>Pensata per la sicurezza del tuo gatto.</h2>
                                <p>
                                    A differenza delle lettiere rotanti tradizionali, Kleeo utilizza un <strong>design a corpo fisso (Integrated Bucket Body)
                                    </strong>. Il guscio esterno non si muove, eliminando ogni fessura pericolosa.

                                    Il design è privo di lame o meccanismi di taglio.
                                    In combinazione con sensori di peso e infrarossi,
                                    il sistema interrompe automaticamente il ciclo
                                    quando rileva la presenza del gatto.
                                </p>
                                <div className="safety-features">
                                    <div className="safety-feature">
                                        <div className="sf-icon">
                                            <i className="ti-shield"></i>
                                        </div>
                                        <div className="sf-text">
                                            <h5>Design senza lame né cesoiamento</h5>
                                            <p>Il sistema si blocca automaticamente quando rileva la presenza del gatto.</p>
                                        </div>
                                    </div>
                                    <div className="safety-feature">
                                        <div className="sf-icon">
                                            <i className="ti-pulse"></i>
                                        </div>
                                        <div className="sf-text">
                                            <h5><strong>Celle di carico:</strong> </h5>
                                            <p>sensibilità estrema per gatti da 1 a 10kg.</p>
                                        </div>
                                    </div>
                                    <div className="safety-feature">
                                        <div className="sf-icon">
                                            <i className="ti-medall"></i>
                                        </div>
                                        <div className="sf-text">
                                            <h5><strong>Testata agli urti:</strong></h5>
                                            <p>certificata per resistere a cadute da 760mm.</p>
                                        </div>
                                    </div>
                                    <div className="safety-feature">
                                        <div className="sf-icon">
                                            <i className="ti-lock"></i>
                                        </div>
                                        <div className="sf-text">
                                            <h5>Doppio sistema di rilevamento</h5>
                                            <p>Sensori di peso multipli e sensori infrarossi attivi rilevano il gatto e bloccano immediatamente il ciclo.</p>
                                        </div>
                                    </div>
                                    <div className="safety-feature">
                                        <div className="sf-icon">
                                            <i className="ti-eye"></i>
                                        </div>
                                        <div className="sf-text">
                                            <h5>Monitoraggio via App TUYA</h5>
                                            <p>Peso del gatto, orari di utilizzo, numero di accessi: tutto sotto controllo in tempo reale dal tuo smartphone.</p>
                                        </div>
                                    </div>
                                    <div className="safety-feature">
                                        <div className="sf-icon">
                                            <i className="ti-check"></i>
                                        </div>
                                        <div className="sf-text">
                                            <h5>Ingresso ultra-basso 140mm</h5>
                                            <p>Pensato per gatti di tutte le taglie, da 1 a 10 kg. Anche i gatti anziani o con mobilita ridotta entrano senza difficolta.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SMART APP - Sezione 5 */}
            <section id="salute-app" className="landing-app section-padding-monitoraggio">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12">
                            <div className="app-content">
                                <span className="landing-badge">Salute del gatto</span>
                                <h2>La salute del tuo gatto sotto controllo.</h2>
                                <p>Grazie alla compatibilità con l'ecosistema <strong>Tuya Smart</strong>, Kleeo invia dati precisi sul peso del tuo gatto
                                    e sulla frequenza d'uso direttamente sul tuo smartphone.
                                    Un alleato prezioso per prevenire problemi urinari o monitorare cali di peso improvvisi.</p>
                                <ul className="app-features-list">
                                    <li><i className="ti-check"></i> Rilevazione peso: monitoraggio costante della salute del tuo gatto.</li>
                                    <li><i className="ti-check"></i> Log attività: traccia orari e durata di ogni utilizzo in tempo reale.</li>
                                    <li><i className="ti-check"></i> Prevenzione salute: storico dati per individuare precocemente anomalie urinarie.</li>
                                    <li><i className="ti-check"></i> Controllo Remoto: avvia un ciclo di pulizia o cambia modalità con un tocco.</li>
                                    <li><i className="ti-check"></i> Notifiche Push: ricevi un avviso quando il cassetto rifiuti è pieno.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 d-flex align-items-center">
                            <div className="app-image">
                                <img src={imgMonitoraggio} alt="App TUYA monitoraggio lettiera" />
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            {/* PUNTI DI FORZA - Sezione 6 */}
            <section className="landing-comparison section-padding-speciale">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-12">
                            <div className="section-title">
                                <h3>Caratteristiche</h3>
                                <h2>Cosa la rende speciale</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step-card">
                                <div className="step-icon-wrap">
                                    <div className="step-icon" style={{ background: '#FFEFEB' }}>
                                        <i className="ti-shield"></i>
                                    </div>
                                </div>
                                <h4>Design Safe-Dome</h4>
                                <p>Struttura esterna fissa senza meccanismi di cesoiamento. Sensori infrarossi e celle di carico garantiscono protezione totale.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step-card">
                                <div className="step-icon-wrap">
                                    <div className="step-icon" style={{ background: '#E8F4FF' }}>
                                        <i className="ti-heart"></i>
                                    </div>
                                </div>
                                <h4>65L di capacità</h4>
                                <p>Vano interno extra-large progettato per il massimo comfort. Ideale per gatti da 1 a 10 kg, comprese le razze più grandi.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step-card">
                                <div className="step-icon-wrap">
                                    <div className="step-icon" style={{ background: '#FFF7E5' }}>
                                        <i className="ti-arrow-down"></i>
                                    </div>
                                </div>
                                <h4>Accesso facilitato</h4>
                                <p>Ingresso a soli 140 mm da terra. Pensato per gatti di ogni età, inclusi cuccioli, gatti anziani o con mobilità ridotta.</p>                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step-card">
                                <div className="step-icon-wrap">
                                    <div className="step-icon" style={{ background: '#E5FDFF' }}>
                                        <i className="ti-reload"></i>
                                    </div>
                                </div>
                                <h4>Fino a 15 giorni di autonomia*</h4>
                                <p>Cassetto rifiuti da 9L sigillato. Svuotamento rapido con un solo pulsante e tamburo interno lavabile per un'igiene profonda.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step-card">
                                <div className="step-icon-wrap">
                                    <div className="step-icon" style={{ background: '#F3E8FF' }}>
                                        <i className="ti-spray"></i>
                                    </div>
                                </div>
                                <h4>Purificazione ionica</h4>
                                <p>Sistema avanzato che neutralizza gli odori elettronicamente. L'aria della tua casa resta fresca e pulita 24 ore su 24.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="step-card">
                                <div className="step-icon-wrap">
                                    <div className="step-icon" style={{ background: '#E8F4FF' }}>
                                        <i className="ti-mobile"></i>
                                    </div>
                                </div>
                                <h4>App TUYA (Wi-Fi)</h4>
                                <p>Monitora peso, frequenza e orari di utilizzo. Gestisci i cicli di pulizia e ricevi notifiche sulla salute ovunque ti trovi.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-12">
                            <p className="faq-disclaimer">*Autonomia riferita a un gatto di circa 4 kg. Può variare in base al numero di gatti, peso e tipo di sabbia utilizzata.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ODORI E IGIENE - Sezione 7 */}
            <section className="landing-deodorization section-padding-deo">
                <div className="deodorization-bg"></div>
                <div className="deodorization-image">
                    <img src={imgOdori} alt="Sistema purificazione ionica a pressione negativa" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-12">
                            <div className="deodorization-content">
                                <span className="landing-badge">Aria pura, sempre.</span>
                                <h2>Dimentica i cattivi odori.</h2>
                                <p>
                                    Kleeo integra un sistema di <strong>deodorizzazione elettronica a ioni</strong> che neutralizza le molecole odorigene subito dopo l'uso.
                                    Il cassetto rifiuti da 9L è sigillato, garantendo fino a 15 giorni di autonomia per un gatto di taglia media.
                                </p>
                                <ul className="deodorization-list">
                                    <li><i className="ti-check"></i> Purificazione Ionica: neutralizza le molecole di odore a livello microscopico.</li>
                                    <li><i className="ti-check"></i> Deodorizzazione Immediata: il ciclo si attiva subito dopo l'uso per bloccare gli odori alla fonte.</li>
                                    <li><i className="ti-check"></i> Cassetto Sigillato: il contenitore da 9L isola i rifiuti dal resto dell'ambiente.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SEZIONE PROGRAMMA PIONIERI & PRICING - Sezione 8 */}
            <section id="prezzi" className="pioneer-pricing-area section-padding-pricing bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center">
                                <span className="pioneer-badge">🇮🇹 LANCIO UFFICIALE ITALIA</span>
                                <h2 className="mt-3">Entra nel Programma Pionieri Petlox</h2>
                                <p className="lead">
                                    Aiutaci a far conoscere Petlox in Italia. Risparmia 100€ sul prezzo di listino e ricevi assistenza prioritaria in cambio della tua opinione.
                                </p>

                                <div className="pioneer-stock-wrapper mt-5">
                                    <div className="d-flex justify-content-between mb-2">
                                        <span className="stock-text">Posti Pionieri disponibili: <strong>8 su 50</strong></span>
                                        <span className="stock-percent">84% Esaurito</span>
                                    </div>
                                    <div className="progress-container">
                                        <div className="progress-fill" style={{ width: '84%' }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="pioneer-trust-bullets mt-2 mb-5">
                        <div className="bullet-item">
                            <div className="bullet-icon">
                                <i className="ti-truck"></i>
                            </div>
                            <div className="bullet-text">
                                <strong>Spedizione 24/48h</strong>
                                <span>Corriere Espresso Gratis</span>
                            </div>
                        </div>
                        <div className="bullet-item">
                            <div className="bullet-icon">
                                <i className="ti-shield"></i>
                            </div>
                            <div className="bullet-text">
                                <strong>Garanzia Italia</strong>
                                <span>24 mesi di copertura totale</span>
                            </div>
                        </div>
                        <div className="bullet-item">
                            <div className="bullet-icon">
                                <i className="ti-comments-smiley"></i>
                            </div>
                            <div className="bullet-text">
                                <strong>Assistenza WhatsApp</strong>
                                <span>Supporto 7/7</span>
                            </div>
                        </div>
                    </div>

                    <div className="row-gap mt-15 align-items-stretch">
                        {/* Kit Essenziale */}
                        <div className="col-12 col-lg-4">
                            <div className="pioneer-card">
                                <div className="card-body">
                                    <h4>Kleeo Essenziale</h4>
                                    <p className="description">Ideale per chi vuole testare la tecnologia risparmiando al massimo.</p>
                                    <div className="price-box">
                                        <span className="old-price">€499</span>
                                        <span className="new-price">€399</span>
                                    </div>
                                    <p className="price-note">IVA e spedizione incluse</p>
                                    <ul className="feature-list">
                                        <li><i className="ti-check"></i> 1x Lettiera Smart Kleeo</li>
                                        <li><i className="ti-check"></i> Set base 20 sacchetti (1 mese)</li>
                                        <li><i className="ti-check"></i> App Tuya inclusa</li>
                                        <li><i className="ti-check"></i> Garanzia 2 anni</li>
                                        <li><i className="ti-check"></i> Spedizione Gratuita</li>
                                    </ul>
                                    <Link onClick={() => window.scrollTo(0, 0)} to="/shop" className="btn-pioneer-outline">Acquista ora</Link>
                                </div>
                            </div>
                        </div>

                        {/* Kleeo Pioneer Kit */}
                        <div className="col-12 col-lg-4">
                            <div className="pioneer-card featured">
                                <div className="best-value-tag">PIÙ SCELTO / BEST VALUE</div>
                                <div className="card-body">
                                    <h4>Kleeo Pioneer Kit</h4>
                                    <p className="description">Tutto il necessario per 3 mesi di relax.</p>
                                    <div className="price-box">
                                        <span className="old-price">€529</span>
                                        <span className="new-price">€429</span>
                                    </div>
                                    <p className="price-note">IVA e spedizione incluse</p>
                                    <ul className="feature-list">
                                        <li><i className="ti-check"></i> 1x Lettiera Smart Kleeo</li>
                                        <li><i className="ti-check"></i> <strong>Scorta 6 mesi di sacchetti (120 pz)</strong></li>
                                        <li><i className="ti-check"></i> <strong>2x Confezioni di Sabbia Tecnica Anti-odore</strong></li>
                                        <li><i className="ti-check"></i> App Tuya con monitoraggio salute</li>
                                        <li><i className="ti-check"></i> Spedizione Gratuita</li>
                                        <li><i className="ti-check"></i> Prova di 30 giorni "Soddisfatti o Rimborsati"</li>
                                    </ul>
                                    <Link onClick={() => window.scrollTo(0, 0)} to="/shop" className="btn-pioneer-main">Diventa un Pionere</Link>
                                </div>
                            </div>
                        </div>

                        {/* Kleeo Double Pack */}
                        <div className="col-12 col-lg-4">
                            <div className="pioneer-card">
                                <div className="card-body">
                                    <h4>Kleeo Double Pack</h4>
                                    <p className="description">Per case con più gatti o su più piani.</p>
                                    <div className="price-box">
                                        <span className="old-price">€998</span>
                                        <span className="new-price">€749</span>
                                    </div>
                                    <p className="price-note">IVA e spedizione incluse</p>
                                    <ul className="feature-list">
                                        <li><i className="ti-check"></i> 2x Lettiere Smart Kleeo</li>
                                        <li><i className="ti-check"></i> Starter Kit sacchetti per entrambe</li>
                                        <li><i className="ti-check"></i> Supporto Priority H24</li>
                                        <li><i className="ti-check"></i> Spedizione Express Gratuita</li>
                                        <li><i className="ti-check"></i> Garanzia Kleeo Care Estesa (3 anni)</li>
                                        <li><i className="ti-star text-warning"></i> <strong>Risparmio Extra di 50€</strong></li>
                                    </ul>
                                    <Link onClick={() => window.scrollTo(0, 0)} to="/shop" className="btn-pioneer-outline">Ordina ora</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-4">
                        <p className="trust-footer"> Pagamento sicuro al 100% • Consegna in 48h • 2 Anni di Garanzia Italiana</p>
                    </div>
                </div>
            </section>

            {/* TESTIMONIAL - Sezione 9 */}
            <section className="landing-testimonials section-padding-testimonial">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-12">
                            <div className="section-title">
                                <h3>Recensioni</h3>
                                <h2>Cosa dicono i nostri clienti</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="testimonial-card-landing">
                                <div className="tc-stars">
                                    {[...Array(5)].map((_, i) => <i key={i} className="fa fa-star"></i>)}
                                </div>
                                <p>"Il mio Maine Coon da 8kg entra senza problemi grazie all'ingresso basso. Con il contenitore da 9 litri cambio il sacchetto ogni due settimane. Comodo e pratico."</p>
                                <div className="tc-author">
                                    <div className="tc-avatar">G</div>
                                    <div className="tc-info">
                                        <h5>Giulia R.</h5>
                                        <span>Milano - Maine Coon, 8kg</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="testimonial-card-landing">
                                <div className="tc-stars">
                                    {[...Array(5)].map((_, i) => <i key={i} className="fa fa-star"></i>)}
                                </div>
                                <p>"Avevo paura per la sicurezza, ma il design senza lame mi ha convinto. I sensori di peso e infrarossi bloccano il ciclo se il gatto si avvicina. La purificazione ionica elimina davvero gli odori."</p>
                                <div className="tc-author">
                                    <div className="tc-avatar">M</div>
                                    <div className="tc-info">
                                        <h5>Marco T.</h5>
                                        <span>Roma - Europeo, 5kg</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="testimonial-card-landing">
                                <div className="tc-stars">
                                    {[...Array(5)].map((_, i) => <i key={i} className="fa fa-star"></i>)}
                                </div>
                                <p>"A €399 costa la metà di un Litter-Robot. Il vano da 65 litri è enorme, i miei due Persiani la usano senza problemi a turno. Con l'app TUYA controllo peso e abitudini di entrambi dal telefono."</p>
                                <div className="tc-author">
                                    <div className="tc-avatar">S</div>
                                    <div className="tc-info">
                                        <h5>Sara M.</h5>
                                        <span>Napoli - 2 gatti Persiani</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ - Sezione 10 */}
            <section className="landing-faq section-padding-faq">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-12">
                            <div className="section-title">
                                <h3>FAQ</h3>
                                <h2>Domande frequenti</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-12">
                            <div className="faq-list">
                                {/* FAQ 1 */}
                                <div className="faq-item">
                                    <input type="checkbox" id="faq1" className="faq-toggle" />
                                    <label htmlFor="faq1" className="faq-question">
                                        <span>La lettiera automatica emana cattivi odori?</span>
                                        <i className="ti-angle-down"></i>
                                    </label>
                                    <div className="faq-answer">
                                        <p>No, al contrario: il contenitore rifiuti da 9L è sigillato e il sistema di purificazione ionica neutralizza attivamente le molecole odorigene subito dopo ogni utilizzo. L'aria della stanza rimane fresca, a differenza delle lettiere tradizionali dove i bisogni restano esposti.</p>
                                    </div>
                                </div>

                                {/* FAQ 2 */}
                                <div className="faq-item">
                                    <input type="checkbox" id="faq2" className="faq-toggle" />
                                    <label htmlFor="faq2" className="faq-question">
                                        <span>È adatta a gatti grandi (Maine Coon, Norvegese)?</span>
                                        <i className="ti-angle-down"></i>
                                    </label>
                                    <div className="faq-answer">
                                        <p>Sì! Con un vano interno da 65 litri e una portata testata fino a 10 kg, Kleeo è progettata per ospitare comodamente razze grandi. L'ingresso facilitato a soli 140 mm da terra è tra i più bassi della categoria, ideale per il comfort di gatti di ogni taglia.</p>
                                    </div>
                                </div>

                                {/* FAQ 3 */}
                                <div className="faq-item">
                                    <input type="checkbox" id="faq3" className="faq-toggle" />
                                    <label htmlFor="faq3" className="faq-question">
                                        <span>È sicura per il mio gatto?</span>
                                        <i className="ti-angle-down"></i>
                                    </label>
                                    <div className="faq-answer">
                                        <p>Assolutamente sì. Il design Safe-Dome a corpo fisso elimina ogni rischio di schiacciamento o cesoiamento. Sensori infrarossi attivi e celle di carico di precisione rilevano istantaneamente l'avvicinamento del gatto, bloccando ogni movimento in tempo reale.</p>
                                    </div>
                                </div>

                                {/* FAQ 5 */}
                                <div className="faq-item">
                                    <input type="checkbox" id="faq5" className="faq-toggle" />
                                    <label htmlFor="faq5" className="faq-question">
                                        <span>Che tipo di lettiera devo usare?</span>
                                        <i className="ti-angle-down"></i>
                                    </label>
                                    <div className="faq-answer">
                                        <p>Kleeo è ottimizzata per sabbia minerale agglomerante (bentonite) di alta qualità. Il serbatoio è tarato per circa 4.5 kg di sabbia. L'uso di sabbie minerali garantisce la massima precisione dei sensori di peso e una separazione perfetta dei rifiuti.</p>
                                    </div>
                                </div>

                                {/* FAQ 6 */}
                                <div className="faq-item">
                                    <input type="checkbox" id="faq6" className="faq-toggle" />
                                    <label htmlFor="faq6" className="faq-question">
                                        <span>Quanto rumore fa durante la pulizia?</span>
                                        <i className="ti-angle-down"></i>
                                    </label>
                                    <div className="faq-answer">
                                        <p>È estremamente silenziosa: meno di 45dB, paragonabile a un leggero fruscio o al ronzio di un frigorifero moderno. È possibile tenerla in salotto o in camera senza che il rumore disturbi il riposo tuo o del tuo gatto.</p>
                                    </div>
                                </div>

                                {/* FAQ 7 */}
                                <div className="faq-item">
                                    <input type="checkbox" id="faq7" className="faq-toggle" />
                                    <label htmlFor="faq7" className="faq-question">
                                        <span>Cosa succede se va via la corrente?</span>
                                        <i className="ti-angle-down"></i>
                                    </label>
                                    <div className="faq-answer">
                                        <p>Se manca la corrente, il ciclo di pulizia si ferma per sicurezza. La lettiera resta perfettamente accessibile e utilizzabile dal gatto come una normale lettiera aperta. Al ripristino dell'energia, il sistema si riavvia e grazie alla connessione Wi-Fi torna subito online con le tue impostazioni predefinite.</p>
                                    </div>
                                </div>

                                {/* FAQ 8 */}
                                <div className="faq-item">
                                    <input type="checkbox" id="faq8" className="faq-toggle" />
                                    <label htmlFor="faq8" className="faq-question">
                                        <span>Il mio gatto è pauroso, si spaventerà?</span>
                                        <i className="ti-angle-down"></i>
                                    </label>
                                    <div className="faq-answer">
                                        <p>Kleeo è molto silenziosa e discreta. Il ciclo di pulizia parte solo quando il gatto è lontano e si interrompe se lui prova a rientrare. L'ingresso basso e la stabilità del corpo fisso comunicano sicurezza al gatto, facilitando l'abituazione anche dei soggetti più timidi in pochi giorni.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-12">
                            <p className="faq-disclaimer">*I dati di autonomia e utilizzo si basano su test con un gatto di 4 kg e possono variare in base a peso, numero di gatti e tipo di sabbia.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA FINALE - Sezione 11 */}
            <section className="landing-cta-final section-padding-cta">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12">
                            <div className="landing-cta-inner">
                                <h2>Libera il tuo tempo, proteggi il tuo gatto.</h2>
                                <p>Design Safe-Dome, 65L di comfort e 24 mesi di Garanzia Italia. Unisciti ai primi 50 Pionieri Kleeo.</p>
                                <div className="landing-cta-actions">
                                    <a href="#prezzi" className="theme-btn-s2">Ordina ora - da €399</a>
                                </div>
                                <div className="landing-cta-trust">
                                    <span><i className="ti-truck"></i> Spedizione gratuita</span>
                                    <span><i className="ti-reload"></i> 30gg Prova Soddisfatti o Rimborsati</span>
                                    <span><i className="ti-shield"></i> Assistenza in Italiano</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="cta-image">
                                <img src={imgLifestyle} alt="Gatto con lettiera autopulente" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </div>
    );
};

export default Landing;
